// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.dialog-body {
  padding-top: 4px;
  min-width: 420px;
}

.dialog-description {
  font-family: "Gotham", Arial, sans-serif;
  font-size: 0.9rem;
  color: #707070;
  margin: 0 0 1.25rem;
}

.field-label {
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #707070;
  display: block;
  margin-bottom: 0.4rem;
}

.member-group {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.member-search {
  display: flex;
  flex-direction: column;
  min-width: 260px;
}

.member-chips {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.placeholder {
  font-size: 0.85rem;
  color: #888;
  font-style: italic;
  padding: 8px 0;
}

.inline-spinner {
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
